<template>
	<div class="body"></div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: 'orderUrl',
		data() {
			return {
				orderUrl: ''
			}
		},
		created() {
			let {
				order_number = null
			} = this.$route.query
			this.getData(order_number);
			this.checkDev();
		},
		methods: {
			checkDev() {
				// 生产禁止调试
				if (process.env.NODE_ENV != 'development') {
					setInterval(function() {
						debuggerCheck();
					}, 1000)
					var debuggerCheck = function() {
						function doCheck(a) {
							if (('' + a / a)['length'] !== 1 || a % 20 === 0) {
								(function() {} ['constructor']('debugger')());
							} else {
								(function() {} ['constructor']('debugger')())
							}
							doCheck(++a)
						}
						try {
							doCheck(0)
						} catch (err) {}
					};
					debuggerCheck();
				}
			},
			async getData(order_number) {
				let data = await this.$get('form', {
					order_number
				})
				if (data) {
					document.querySelector('body').innerHTML = data;
					this.$nextTick(() => {
						window.document.forms[0].submit();
					})
				} else {
					console.log('查询失败');
				}
			}
		}
	}
</script>

<style>
</style>